<div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-px-3 tw-pb-2 tw-text-center">
  <div
    class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-w-full tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-4"
  >
    <div
      class="tw-flex tw-items-center tw-justify-center tw-w-[56px] tw-h-[56px] tw-rounded-full tw-bg-color-status-success-bg"
    >
      <icon [size]="7" [name]="'check-thin'" [currentColor]="'color-status-success-text'"></icon>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-1">
      <span class="tw-font-semibold tw-text-xl tw-tracking-[-0.1px] tw-text-color-text-default">
        @if (goldAdded() !== null) {
          {{ "creditsAddedHeadline" | i18n: (goldAdded() | number) }}
        } @else {
          {{ "goldCreditsAdded" | i18n }}
        }
      </span>
      <span class="tw-text-sm tw-font-medium tw-text-color-text-secondary">
        {{ subtitle() }}
      </span>
    </div>
  </div>

  <div
    class="tw-flex tw-flex-col tw-gap-3 tw-w-full tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-4 tw-text-left"
  >
    <span class="tw-text-xs tw-font-medium tw-uppercase tw-text-color-text-secondary">
      {{ "receipt" | i18n }}
    </span>
    @for (row of rows(); track row.label) {
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
        <span
          class="tw-text-sm"
          [ngClass]="
            row.highlight
              ? 'tw-font-semibold tw-text-color-text-default'
              : 'tw-font-medium tw-text-color-text-secondary'
          "
        >
          {{ row.label }}
        </span>
        <span
          class="tw-flex tw-items-baseline tw-gap-1 tw-text-right"
          [ngClass]="
            row.unit
              ? 'tw-font-montserrat tw-font-semibold tw-text-[12px] tw-leading-none tw-text-color-text-default'
              : 'tw-text-sm tw-font-semibold tw-text-color-text-default'
          "
        >
          {{ row.value }}
          @if (row.unit) {
            <span class="tw-text-xs tw-font-medium tw-text-color-text-tertiary">{{
              row.unit
            }}</span>
          }
        </span>
      </div>
    }
  </div>

  <button
    type="button"
    (click)="done()"
    [style.background]="glassButtonBg"
    [style.box-shadow]="glassButtonShadow"
    class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-h-[56px] tw-px-8 tw-py-3 tw-mt-16 tw-rounded-2xl tw-border-[1.5px] tw-border-white/60 dark:tw-border-white/[0.18] tw-text-[16px] tw-font-semibold tw-leading-[24px] tw-tracking-[0.005em] tw-text-color-text-on-action"
  >
    {{ "done" | i18n }}
  </button>
</div>
